export default __webpack_public_path__ + "static/media/005.6170b32e.jpg";